import {
  getTextFromVisibleValues,
  TableCondition
} from 'cadenza/conditions/table-condition/table-condition';
import { AreaConditionApi } from 'cadenza/api-client/conditions/area-condition-api';
import { errorAlert } from 'cadenza/alert';
import { hashCode } from 'cadenza/utils/hash-code';

import i18n from './messages.properties';

class AreaCondition extends TableCondition {

  constructor () {
    super({
      columnsConfigSupplier: data => data.conditionLevelDefinition.levels,
      conditionApiSupplier: configObject => new AreaConditionApi(configObject)
    });
  }

  createRowConverter () {
    return row => `${row.formatted.filter(v => v != null).join(', ')} (${row.areaConditionLevelName})`;
  }

  /**
   * Overwrites the method in table-condition.js
   *
   * @param {object[]} rows - the initial rows
   * @return {object[]} the modified rows
   */
  prepareRows (rows) {
    return rows.map(row => {
      row.value = row.values;
      row.id = String(hashCode(JSON.stringify(row.values)));
      row.text = getTextFromVisibleValues(row.values, this._tableColumnsDef[0].tableColumns.columns);
      return row;
    });
  }

  showDialog () {
    return import(/* webpackChunkName: "area-condition-modal" */ './area-condition-modal/area-condition-modal').then(({ AreaConditionTableModal }) => {
      const dialog = new AreaConditionTableModal({
        title: this.conditionLabel,
        conditionApi: this.conditionApi,
        selectedRows: this.value,
        maxSelection: this.maxSelection,
        conditionId: this.conditionId,
        levelsDefinition: this._tableColumnsDef
      });
      dialog.addEventListener('close', () => {
        dialog.remove();
        if (dialog.returnValue) {
          this.value = dialog.returnValue;
          this.onConditionChange();
        }
      });
      document.body.appendChild(dialog);
      dialog.showModal();
    }).catch(() => errorAlert(
      i18n('error.dialog.title'),
      i18n('error.dialog.message')));
  }

}

customElements.define('d-area-condition', AreaCondition);
